module.exports = __webpack_public_path__ + "img/yzh2.f58a65c9.jpg";